<div class="astral-stack-l">
  @if (allowLinkCompanyDocument) {
    <div class="astral-action-with-help">
      <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_WITH_DLG_BTN" (click)="linkDocument()"></astral-button>
    </div>
  }
  <app-list-view
    [columnDefinition]="documentsColumnDefinition"
    [itemsSource]="company.documents"
    [contextMenuDefinition]="documentsContextMenuDefinitions"
    [preferencesKey]="'rent.company-document.documents'"
  ></app-list-view>
</div>
